// shared/global app constants

export const CHANGE_EVENT = 'change';
export const DEPLOYED_PRODUCT_ID = 'deployedProductId';
export const GET_COUNT_DELAY = 1500;
export const INITIALISE_EVENT = 'initialise';
export const SITENAME_KEY = 'sitename';

export const OPERATION = 'operation';
export const OPERATIONS = 'operations';
export const INFRINGEMENT = 'infringement';
export const INFRINGEMENTS = 'infringements';
export const NOISEEVENT = 'noiseevent';
export const NOISEEVENTS = 'noiseevents';
export const FILTER = 'filter';
export const FILTER_ROW_SELECTION = 'filter.row';
export const FILTER_RANGE_SELECTION = 'filter.range';
export const FILTER_TIME_SELECTION = 'filter.time';

export const DATA_FILTER_DIR = 'data/filters/';

// local storage keys
export const USER_SETTINGS = 'user.settings';

// Possible product IDs
// Only used for local development
export const PRODUCT_PANY = 'x_pany';
export const PRODUCT_SZG = 'szg';
export const PRODUCT_SZG_ANOMSX = 'szg.anomsx';
export const PRODUCT_LHR = 'lhr';
export const PRODUCT_LHR_ANOMSX = 'lhr.anomsx';
export const PRODUCT_BNE = 'bne';
export const PRODUCT_BNE_ANOMSX = 'bne.anomsx';
export const PRODUCT_LHR_PT = 'lhr.pt';
export const PRODUCT_KEF = 'kef';

export const CORRELATED_TYPES = {
  INFRINGEMENT: 'infringement',
  NOISEEVENT: 'noiseevent',
};

export const CORRIDOR_INFRINGEMENT = 'Corridor';
export const EXCLUSION_INFRINGEMENT = 'Exclusion';
export const GATE_INFRINGEMENT = 'Gate';
export const CURFEW_INFRINGEMENT = 'Curfew';
export const CCO_INFRINGEMENT = 'Cco';
export const CDO_INFRINGEMENT = 'Cdo';
export const MINHEIGHT_INFRINGEMENT = 'MinHeight';
export const NOISE_INFRINGEMENT = 'Noise';

// comment status
export const COMMENT_STATUS_LOADED = 'loaded';
export const COMMENT_STATUS_LOADING = 'loading';
export const COMMENT_STATUS_SAVED = 'saved';

// status options
export const NULL_VALUE = 'NullValue';
export const VECTORED = 'vectored';

// Metric
export const METRIC_DECIBEL = 'dB';
export const METRIC_SECONDS = 'sec';
export const METRIC_METER = 'm';
export const METRIC_METER_PER_SECOND = 'm/s';
export const METRIC_KILOMETER = 'km';
export const METRIC_HECTOPASCALS = 'hPa';
export const METRIC_FEET = 'ft';
export const METRIC_PERCENTAGE = '%';
export const METRIC_CELSIUS = 'C';
export const METRIC_KNOTS = 'kn';

export const DECIBEL_FILTER_MIN = 0;
export const DECIBEL_FILTER_MAX = 140;
export const SECONDS_FILTER_MIN = 0;
export const SECONDS_FILTER_MAX = 240;
export const ERROR_MAX_GREATER_THAN_MIN = 'maxGreaterThanMin';

export const DEFAULT_BBOX_DISTANCE = 320;
export const FLY_TO_DURATION = 800;
